
import React from 'react'

import ResponsivePageToolbar from './ResponsivePageToolbar'

export interface ContentHeaderToolbarButton {
  label: string
  icon: string | JSX.Element
  onClick: any
  className?: string
  disabled?: boolean
  active?: boolean
  mobilePrimary?: boolean
}

interface Props {
  buttons: ContentHeaderToolbarButton[]
}

const ContentHeaderToolbar = ({ buttons }: Props) => {

  const primaryButton = buttons.find(button => button.mobilePrimary)
  const secondaryButtons = buttons.filter(button => !button.mobilePrimary)

  const renderButton = (button: ContentHeaderToolbarButton) => (
    <button
      type="button"
      className={`btn btn-link btn-link-header ${button.className || ''} ${button.active ? 'active' : ''}`}
      onClick={button.onClick}
      disabled={button.disabled}
      aria-label={button.label}
      title={button.label}
    >
      {button.icon}
      <span>{button.label}</span>
    </button>
  )

  return (
    <ResponsivePageToolbar
      primaryAction={primaryButton ? renderButton(primaryButton) : undefined}
      actions={secondaryButtons.map(button => ({
        label: button.label,
        icon: button.icon as JSX.Element,
        onClick: button.onClick,
        disabled: button.disabled,
        active: button.active,
        className: button.className,
      }))}
    />
  )
}

export default ContentHeaderToolbar
